/**
 * @generated SignedSource<<9f4b6adcd9669a81deda4a90e129666e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type comment_parentComment$data = {
  readonly childrenCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"commentFragment" | "comment_childrenComments">;
  readonly " $fragmentType": "comment_parentComment";
};
export type comment_parentComment$key = {
  readonly " $data"?: comment_parentComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"comment_parentComment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "comment_parentComment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "commentFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "comment_childrenComments"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "childrenCount",
      "storageKey": null
    }
  ],
  "type": "CommentInterface",
  "abstractKey": "__isCommentInterface"
};

(node as any).hash = "8ad44f00829812b3dff049a227f64022";

export default node;
